import { CreateFormTopBarConfig } from './CreateFormTopBar';

export const TOPBAR_CONFIGS = {
  MATTER_CHECKLIST: {
    title: 'Create a Checklist',
    routeFlagKey: 'matters-create-checklist',
    paramName: 'matterId' as const,
    cancelPath: '/matterDetails/{matterId}/tasks',
    saveAriaLabel: 'Create checklist',
    useCreateButton: true,
  } satisfies CreateFormTopBarConfig,

  MATTER_TASKS: {
    title: 'Create a Task',
    routeFlagKey: 'matters-create-tasks',
    paramName: 'matterId' as const,
    cancelPath: '/matterDetails/{matterId}/tasks',
    saveAriaLabel: 'Create task',
    useCreateButton: true,
  } satisfies CreateFormTopBarConfig,

  PROJECT_CHECKLIST: {
    title: 'Create a Checklist',
    routeFlagKey: 'projects-create-checklist',
    paramName: 'matterId' as const,
    pageContextKey: 'projectId',
    cancelPath: '/projectDetails/{matterId}/tasks',
    saveAriaLabel: 'Create checklist',
    useCreateButton: true,
  } satisfies CreateFormTopBarConfig,

  PROJECT_TASKS: {
    title: 'Create a Task',
    routeFlagKey: 'projects-create-tasks',
    paramName: 'matterId' as const,
    pageContextKey: 'projectId',
    cancelPath: '/projectDetails/{matterId}/tasks',
    saveAriaLabel: 'Create task',
    useCreateButton: true,
  } satisfies CreateFormTopBarConfig,

  MERGE_PROJECT_CHECKLIST: {
    title: 'Create a Checklist',
    routeFlagKey: 'merge-projects-create-checklist',
    paramName: 'matterId' as const,
    pageContextKey: 'projectId',
    cancelPath: '/projectDetails/{matterId}/tasks',
    saveAriaLabel: 'Create checklist',
    useCreateButton: true,
  } satisfies CreateFormTopBarConfig,

  MERGE_PROJECT_TASKS: {
    title: 'Create a Task',
    routeFlagKey: 'merge-projects-create-tasks',
    paramName: 'matterId' as const,
    pageContextKey: 'projectId',
    cancelPath: '/projectDetails/{matterId}/tasks',
    saveAriaLabel: 'Create task',
    useCreateButton: true,
  } satisfies CreateFormTopBarConfig,

  TASKS_CHECKLIST: {
    title: 'Create a Checklist',
    routeFlagKey: 'tasks-create-checklist',
    cancelPath: '/tasks',
    saveAriaLabel: 'Create checklist',
    useCreateButton: true,
  } satisfies CreateFormTopBarConfig,

  TASKS: {
    title: 'Create a Task',
    routeFlagKey: 'tasks-create-task',
    cancelPath: '/tasks',
    saveAriaLabel: 'Create task',
    useCreateButton: true,
  } satisfies CreateFormTopBarConfig,

  CREATE_MATTER: {
    title: 'Create a Matter',
    routeFlagKey: 'matters-create-matter',
    cancelPath: '/matters',
    saveAriaLabel: 'Create matter',
    useCreateButton: true,
  } satisfies CreateFormTopBarConfig,

  CREATE_PROJECT: {
    title: 'Create a Project',
    routeFlagKey: 'projects-create-project',
    cancelPath: '/projects',
    saveAriaLabel: 'Create project',
    useCreateButton: true,
  } satisfies CreateFormTopBarConfig,
} as const;